export default __webpack_public_path__ + "static/media/M2Video.1929cabf.png";